import { render, staticRenderFns } from "./_EmentaTagEditar.vue?vue&type=template&id=509ec940&scoped=true"
import script from "./_EmentaTagEditar.vue?vue&type=script&lang=ts"
export * from "./_EmentaTagEditar.vue?vue&type=script&lang=ts"
import style0 from "./_EmentaTagEditar.vue?vue&type=style&index=0&id=509ec940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ec940",
  null
  
)

export default component.exports